import { render, staticRenderFns } from "./mediaEdit.vue?vue&type=template&id=c82c5d68&scoped=true"
import script from "./mediaEdit.vue?vue&type=script&lang=js"
export * from "./mediaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c82c5d68",
  null
  
)

export default component.exports